import template from './ga-map.component.html';
import googleMapsService from './google.maps.service';

class SiteMapController {
  constructor($element, $scope, $q, $timeout, $rootScope) {
    'ngInject';

    this.$element = $element;
    this.$scope = $scope;
    this.$q = $q;
    this.changingGeoZone = false;
    this.$timeout = $timeout;
    this.userMapType = () => $rootScope.currentUser.claims?.data?.mapView;
  }

  $onInit() {
    this.$q
      .resolve(
        googleMapsService.createMap({
          el: this.$element.find('.map-container')[0],
          allowEditGeoZone: this.editable,
          mapType: this.userMapType(),
        }),
      )
      .then(() => {
        if (this.editable) {
          const toolbar = this.$element.find('.toolbar')[0];

          googleMapsService.map.controls[google.maps.ControlPosition.TOP_CENTER].push(toolbar);

          const editActions = this.$element.find('.ga-map-edit-actions')[0];
          googleMapsService.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(editActions);
        }

        const markerDescriptors = this.$element.find('.marker-descriptors')[0];
        googleMapsService.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(
          markerDescriptors,
        );

        if (this.searchable) {
          //search location
          const searchControl = this.$element.find('.map-location-search')[0];
          const searchInput = searchControl.children[0];

          googleMapsService.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(searchControl);

          googleMapsService.setLocationSearch(searchInput);
        }

        if (Array.isArray(this.assets)) {
          googleMapsService.setMarkers(this.assets);
        }

        if (this.geometry) {
          googleMapsService.setGeoZone(this.geometry);
        }

        this.$scope.$watch('gaVm.assets', (assets) => {
          if (Array.isArray(assets)) {
            googleMapsService.setMarkers(assets);
          }
        });

        this.$scope.$watch('gaVm.geometry', (geometry) => {
          googleMapsService.setGeoZone(geometry);
        });
      });
    googleMapsService.vm = this;
  }

  clearGeoZone() {
    googleMapsService.clearGeoZone();
    this.showApplyChanges();
  }

  resetGeoZone() {
    googleMapsService.setGeoZone(this.geometry);
    this.changingGeoZone = false;
  }

  onDrawComplete(geometry) {
    if (this.onUpdateGeometry) {
      this.onUpdateGeometry({ geometry });
    }
  }

  editGeoZones() {
    googleMapsService.setPolygonsEditMode(true);
  }

  showApplyChanges() {
    if (this.newSite) {
      this.applyGeoZoneChanges();
    } else {
      this.$timeout(() => (this.changingGeoZone = true));
    }
  }

  applyGeoZoneChanges() {
    const geometry = googleMapsService.getPolygonGeometry();
    if (this.onUpdateGeometry) {
      this.onUpdateGeometry({ geometry });
    }
    this.changingGeoZone = false;
    googleMapsService.setPolygonsEditMode(false);
  }
}

export default {
  template,
  controller: SiteMapController,
  controllerAs: 'gaVm',
  bindings: {
    assets: '<',
    geometry: '<',
    editable: '<',
    onUpdateGeometry: '&?',
    newSite: '<',
    searchable: '<',
  },
};
